<title>{{ 'Invoice' | transloco }}</title>

<app-header [showPayButton]="showPayButtonStatus"></app-header>

<router-outlet></router-outlet>

<app-footer data-html2canvas-ignore [showPayButton]="showPayButtonStatus"></app-footer>
